import type { TFunction } from 'i18next'
import type { NavigationItem } from '../components'

export interface NavOptions {
  pathname: string
  role: string | undefined
  isPlatformAdmin: boolean
  t: TFunction<'nav'>
}

function baseItems(pathname: string, t: TFunction<'nav'>): NavigationItem[] {
  return [
    {
      label: t('sidebar.dashboard'),
      href: '/dashboard',
      icon: 'cases',
      isActive: pathname === '/dashboard',
    },
    {
      label: t('sidebar.clients'),
      href: '/clients',
      icon: 'users',
      isActive: pathname === '/clients',
    },
  ]
}

function orgAdminItems(pathname: string, t: TFunction<'nav'>): NavigationItem[] {
  return [
    {
      label: t('sidebar.cases'),
      href: '/org/cases',
      icon: 'cases',
      isActive: pathname === '/org/cases',
    },
    {
      label: t('sidebar.velociraptorTemplates'),
      href: '/org/velociraptor-templates',
      icon: 'server',
      isActive: pathname === '/org/velociraptor-templates',
    },
  ]
}

function platformAdminItems(pathname: string, t: TFunction<'nav'>): NavigationItem[] {
  const startsWith = (prefix: string): boolean => pathname.startsWith(prefix)
  return [
    {
      label: t('sidebar.organisations'),
      href: '/admin/organisations',
      icon: 'infrastructure',
      isActive: startsWith('/admin/organisations'),
    },
    {
      label: t('sidebar.users'),
      href: '/admin/users',
      icon: 'users',
      isActive: startsWith('/admin/users'),
    },
    {
      label: t('sidebar.licenses'),
      href: '/admin/licenses',
      icon: 'analysis',
      isActive: startsWith('/admin/licenses'),
    },
    {
      label: t('sidebar.reports'),
      href: '/admin/reports',
      icon: 'reports',
      isActive: startsWith('/admin/reports'),
    },
    {
      label: t('sidebar.velociraptor'),
      href: '/admin/velociraptor',
      icon: 'server',
      isActive: startsWith('/admin/velociraptor'),
    },
  ]
}

function settingsItem(pathname: string, t: TFunction<'nav'>): NavigationItem {
  return {
    label: t('sidebar.settings'),
    href: '/admin/settings',
    icon: 'settings',
    isActive: pathname.startsWith('/admin/settings'),
  }
}

export function buildNavigationItems({
  pathname,
  role,
  isPlatformAdmin,
  t,
}: NavOptions): NavigationItem[] {
  const items = baseItems(pathname, t)
  if (role === 'org_admin') items.push(...orgAdminItems(pathname, t))
  if (isPlatformAdmin) items.push(...platformAdminItems(pathname, t))
  items.push(settingsItem(pathname, t))
  return items
}
